import { Button, Col, Row } from 'antd';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faChalkboardTeacher,
} from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './course-element.module.css';

const CourseElement = ({ course }) => {
  const history = useHistory();
  const [t] = useTranslation();
  const courseId = course?.course?.id;

  const goToCourse = () => {
    history.push(`/data/dashboard/course/${courseId}`);
  };

  return (
    <div className={styles.container}>
      <Row
        type="flex"
        align="middle"
        justify="center"
        className={styles.title_container}
      >
        <Col>
          <h2 className={styles.course_title}>{course?.course?.name}</h2>
        </Col>
      </Row>
      <hr className={styles.course_divider} />
      <Row
        type="flex"
        align="middle"
        justify="center"
        className={styles.score_wrapper}
      >
        {/* <Col>
          <h4>Puntaje</h4>
        </Col> */}
      </Row>

      <Row type="flex" align="middle" justify="center">
        <Col>
          <div className={styles.icon_wrapper}>
            {/* <h4>{course?.groupScore}</h4> */}
            <FontAwesomeIcon
              className={styles.class_icon}
              icon={faChalkboardTeacher}
            />
          </div>
        </Col>
      </Row>
      <Row
        type="flex"
        align="middle"
        justify="center"
        className={styles.button_wrapper}
      >
        <Col>
          <Button
            type="primary"
            shape="round"
            onClick={() => goToCourse()}
            className={styles.course_button}
          >
            {t('pages.data.dashBoardSociogram.buttonText')}{' '}
            <FontAwesomeIcon
              className={styles.arrow_icon}
              icon={faArrowRight}
            />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default CourseElement;
